import { LandingChile, LandingPeruNew } from "../../components";
import { useAuthContext } from "../../context/auth";

export const Landing = () => {
  const { pais } = useAuthContext();

  if (pais === "Perú") {
    return <LandingPeruNew />;
  }

  if (pais === "Chile") {
    return <LandingChile />;
  }

  return <div>País no reconocido</div>;
};
